import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-action-list-item.css';
import { EGDSActionListItem } from '../action-list-item/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSActionList = props => {
  const {
    border,
    className,
    children,
    cornerRadius,
    ...attr
  } = props;
  const baseCssClass = 'uitk-action-list';
  const cssClassNames = getClassNameList(className, baseCssClass, {
    [`${baseCssClass}-has-border`]: border,
    [`${baseCssClass}-has-corners`]: cornerRadius
  });
  const newChildren = React.Children.map(children, child => {
    let childProps;
    if (!React.isValidElement(child)) {
      return undefined;
    }
    if (child.type === EGDSActionListItem) {
      childProps = child.props;
      return jsx(EGDSActionListItem, {
        ...childProps,
        role: "listitem"
      });
    }
    return child;
  });
  return jsx("ul", {
    role: "list",
    className: cssClassNames,
    ...attr,
    children: newChildren
  });
};
EGDSActionList.displayName = 'EGDSActionList';
export { EGDSActionList };